import { API_URL } from './gameUtils';

const base = (gameId) => `${API_URL}/api/stats/games/${gameId}`;

const send = (url, method, body) => fetch(url, {
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

const authHeaders = () => {
  const token = localStorage.getItem('session_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

export const statsGameApi = {
  boxscore: (id) => fetch(`${base(id)}/boxscore`),
  onCourt: (id) => fetch(`${base(id)}/on-court`),
  recentEntries: (id) => fetch(`${base(id)}/recent-entries?limit=20`),
  clock: (id) => fetch(`${base(id)}/clock`),
  record: (id, body) => send(`${base(id)}/record`, 'POST', body),
  lineup: (id, team, playerIds) => send(`${base(id)}/lineup`, 'POST', { team, player_ids: playerIds }),
  undo: (id, entryId) => send(`${base(id)}/undo`, 'POST', { entry_id: entryId }),
  setQuarter: (id, quarter) => send(`${base(id)}/quarter`, 'PUT', { quarter }),
  setClock: (id, body) => send(`${base(id)}/clock/set`, 'POST', body),
  clockAction: (id, action) => fetch(`${base(id)}/clock/${action}`, { method: 'POST' }),
  end: (id) => fetch(`${base(id)}/end`, { method: 'POST' }),
  setVideo: (id, videoUrl) => send(`${base(id)}/video`, 'PUT', { video_url: videoUrl }),
  patchEntry: (id, entryId, body) => send(`${base(id)}/entry/${entryId}`, 'PATCH', body),
  patchPlayer: (id, playerId, body) => fetch(`${base(id)}/players/${playerId}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify(body),
  }),
  presence: (id, body) => fetch(`${base(id)}/presence`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(body),
  }),
};
